import { Injectable } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { DeficiencyTypes } from '@core/enums/deficiency-types';
import { Deficiency } from '../models/deficiency';

@Injectable()
export class DeficiencyFilterService {
  public filterDeficiencyDetailsDataSource(
    criteria: { searchText: string; categories: DeficiencyTypes[] },
    deficiencyDetailsDataSource: MatTableDataSource<Deficiency>,
  ) {
    if (deficiencyDetailsDataSource) {
      const emptySearchText = 'EMPTY SEARCH TEXT';
      deficiencyDetailsDataSource.filterPredicate = (data: Deficiency, search: string) => {
        const isTextFilterApplied =
          search === emptySearchText ||
          data.aoComment?.toLocaleUpperCase().includes(search.toLocaleUpperCase()) ||
          data.cml?.toLocaleUpperCase().includes(search) ||
          data.deficiencyType?.toString()?.toLocaleUpperCase().includes(search) ||
          data.equipmentId?.toString()?.toLocaleUpperCase().includes(search) ||
          data.equipmentName?.toString()?.toLocaleUpperCase().includes(search) ||
          data.finding?.toString()?.toLocaleUpperCase().includes(search) ||
          data.ispRecommendation?.toString()?.toLocaleUpperCase().includes(search) ||
          data.aoComment?.toLocaleLowerCase().includes(search.toLocaleLowerCase()) ||
          data.cml?.toLocaleLowerCase().includes(search) ||
          data.deficiencyType?.toString()?.toLocaleLowerCase().includes(search) ||
          data.equipmentId?.toString()?.toLocaleLowerCase().includes(search) ||
          data.equipmentName?.toString()?.toLocaleLowerCase().includes(search) ||
          data.finding?.toString()?.toLocaleLowerCase().includes(search) ||
          data.ispRecommendation?.toString()?.toLocaleLowerCase().includes(search);

        const isCriteriaFilterApplied =
          (this.isCategorySelected(DeficiencyTypes.UTAlarm, criteria.categories) && data.deficiencyType === DeficiencyTypes.UTAlarm) ||
          (this.isCategorySelected(DeficiencyTypes.Redlining, criteria.categories) && data.deficiencyType === DeficiencyTypes.Redlining) ||
          (this.isCategorySelected(DeficiencyTypes.Emergency, criteria.categories) && data.deficiencyType === DeficiencyTypes.Emergency) ||
          (this.isCategorySelected(DeficiencyTypes.High, criteria.categories) && data.deficiencyType === DeficiencyTypes.High) ||
          (this.isCategorySelected(DeficiencyTypes.Standard, criteria.categories) && data.deficiencyType === DeficiencyTypes.Standard) ||
          (this.isCategorySelected(DeficiencyTypes.Routine, criteria.categories) && data.deficiencyType === DeficiencyTypes.Routine) ||
          (this.isCategorySelected(DeficiencyTypes.Observation, criteria.categories) &&
            data.deficiencyType === DeficiencyTypes.Observation);
        return isTextFilterApplied && isCriteriaFilterApplied;
      };
      deficiencyDetailsDataSource.filter = criteria.searchText ? criteria.searchText : emptySearchText;
    }
  }

  private isCategorySelected(category: DeficiencyTypes, categories: DeficiencyTypes[]): boolean {
    return !!categories.find(c => c === category);
  }
}
